import { useTrackAppFirstOpen as _useTrackAppFirstOpen } from '@griply/hooks';
import { AppOpenSources } from '@griply/types';
import { firstOpenStorage } from 'shared/services/local-storage/first-open';

import { useIsSignedIn } from './use-is-signed-in';
import { useTrackEvents } from './use-track-events';

// A browser open has no launch transport to classify; reporting `other` is a product decision, not a DOM limit.
const resolveSource = () => Promise.resolve(AppOpenSources.Other);

export const useTrackAppFirstOpen = () => {
  const track = useTrackEvents();
  const isLoggedIn = useIsSignedIn();

  _useTrackAppFirstOpen({
    isLoggedIn,
    storage: firstOpenStorage,
    resolveSource,
    track,
  });
};
